// material-ui
import { Theme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";

// project imports
import Profile from "./Profile";
import FullScreen from "./FullScreen";
import MobileSection from "./MobileSection";
import AirportSwitcher from "./AirportSwitcher";

import useConfig from "hooks/useConfig";
import { MenuOrientation } from "config";
import DrawerHeader from "layout/Dashboard/Drawer/DrawerHeader";

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const { menuOrientation } = useConfig();

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && (
        <DrawerHeader open={true} />
      )}
      {/* Desktop: only keep full-screen + profile */}
      <Box sx={{ flexGrow: 1 }} />
      <AirportSwitcher compact={downLG} />
      {!downLG && <FullScreen />}
      {!downLG && <Profile />}

      {/* Mobile: keep existing compact header */}
      {downLG && <MobileSection />}
    </>
  );
}
